<template>
  <div class="vue-shape-selector-component">
    <div :class="!allowEdit ? 'disabled-shape-selector': ''" :title="shape.name" :active="shape.plcId == valueModel" @click="setShape(shape)" class="shape-selector-button" v-for="(shape, index) in getShapes" v-bind:key="index">
      <Shape :shape="shape"></Shape>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from "vuex";
import Shape from "@/components/Shape";

export default {
  name: "ShapeSelector",
  props: ['value', 'allowEdit'],
  components: {
    Shape
  },
  data() {
    return {
      valueModel: null,
    }
  },
  computed: {
    ...mapGetters('shapes', ['getShapes'])
  },
  methods: {
    setShape(shape) {
      if (this.allowEdit){
        this.valueModel = shape.plcId;
        this.$emit('change', shape.plcId);
      }

    }
  },
  watch: {
    'value': {
      handler() {
        this.valueModel = this.value;
      }
    }
  },
  created() {
    this.$store.dispatch('shapes/getShapes');
    this.valueModel = this.value;
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/colors";
@import "../assets/scss/variables";

.vue-shape-selector-component {
  width: 100%;
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  grid-auto-flow: column;
}
.shape-selector-button {
  text-align: center;
  padding: calc(#{$default-padding} / 2);
  background: white;
  border-top: 1px solid #D8D8D8;
  border-left: 1px solid #D8D8D8;
  border-bottom: 1px solid #D8D8D8;
  cursor: pointer;
  height: 80px;
}
.shape-selector-button:last-child {
  border-right: 1px solid #D8D8D8;
  border-radius: 0px 12px 12px 0px;
}

.shape-selector-button:first-child {
  border-radius: 12px 0px 0px 12px;
}

.shape-selector-button[active=true] {
  background-color: #4A9AD5;
  color: white;
  font-weight: 700;
}

.disabled-shape-selector[active=true] {
  background-color: #e7e7e7 !important;
  color: white;
  font-weight: 700;
  cursor: not-allowed !important;
}

.disabled-shape-selector {
  cursor: not-allowed !important;
}
</style>
